import { Component, OnInit, inject } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';

import { ToastService } from '@services/toast/toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  animations: [
    trigger('toastState', [
      transition(':enter', [style({ opacity: 1 })]),
      transition(':leave', [style({ opacity: 1 }), animate('500ms', style({ opacity: 0 }))]),
    ]),
  ],
  standalone: false,
})
export class ToastComponent implements OnInit {
  private toastService = inject(ToastService);

  content = '';
  toastState = false;

  ngOnInit() {
    this.toastService.eventShow.subscribe((content) => {
      this.toastState = true;
      this.content = content;
      setTimeout(() => {
        this.toastState = false;
      }, 2000);
    });
  }
}
